import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group cursor-pointer"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-booklet-line text-lg text-background-50"></i>
            </div>
            <span
              className={`font-heading font-bold text-lg whitespace-nowrap transition-colors ${
                scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
              }`}
            >
              今日同人库
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {[
              { to: '/', label: '首页' },
              { to: '/category/doujin-novel', label: '同人小说' },
              { to: '/category/doujin-art', label: '同人画作' },
              { to: '/category/doujin-music', label: '同人音乐' },
              { to: '/category/doujin-goods', label: '周边资讯' },
              { to: '/category/cp-recommend', label: 'CP推荐' },
              { to: '/about', label: '关于我们' },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  location.pathname === item.to
                    ? 'bg-primary-100/70 text-primary-700'
                    : scrolled || !isHome
                      ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
                      : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              className="w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer transition-colors bg-background-100 hover:bg-background-200 text-foreground-600"
              aria-label="搜索"
            >
              <i className="ri-search-line text-base"></i>
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer transition-colors bg-background-100 hover:bg-background-200 text-foreground-700"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/70 bg-background-50 py-3">
            <div className="flex flex-col gap-1">
              {[
                { to: '/', label: '首页' },
                { to: '/category/doujin-novel', label: '同人小说' },
                { to: '/category/doujin-art', label: '同人画作' },
                { to: '/category/doujin-music', label: '同人音乐' },
                { to: '/category/doujin-goods', label: '周边资讯' },
                { to: '/category/cp-recommend', label: 'CP推荐' },
                { to: '/about', label: '关于我们' },
              ].map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`px-4 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                    location.pathname === item.to
                      ? 'bg-primary-100/70 text-primary-700'
                      : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}